const isValidCsv = value => {
  // tests the validity of comma seperated value, not the validity of email address structures
  const regex = /^([^\s,]+,)*([^\s,]+)$/;

  return regex.test(value);
};

export { isValidCsv };
